var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',[(_vm.cleanData[0].data.length!=0)?_c('div',[_c('BarChart',{attrs:{"labels":_vm.labels,"dataset":_vm.cleanData}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }